import React, { useState } from 'react';
import { Box, TextField, IconButton, useTheme, Paper } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';

export const ChatInput = ({ onSendMessage }) => {
    const theme = useTheme();
    const [message, setMessage] = useState('');

    const handleSend = () => {
        if (message.trim()) {
            onSendMessage(message.trim());
            setMessage('');
        }
    };

    const handleKeyPress = (e) => {
        // Sends message on Enter key press, but not if Shift is held (allows for new line)
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    };

    return (
        <Paper 
            elevation={3} 
            sx={{ 
                p: 1, 
                display: 'flex', 
                alignItems: 'flex-end', 
                borderRadius: 2,
                mt: 1,
                bgcolor: theme.palette.background.paper
            }}
        >
            {/* Attachment Button */}
            <IconButton color="primary" aria-label="attach file">
                <AttachFileIcon />
            </IconButton>

            {/* Text Input Field */}
            <TextField
                fullWidth
                multiline
                maxRows={4}
                variant="standard"
                placeholder="Write a message... (Shift + Enter for new line)"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                onKeyDown={handleKeyPress}
                InputProps={{
                    disableUnderline: true, // Remove the standard variant underline
                    sx: { py: 1, px: 1 }
                }}
            />
            
            {/* Emoji Button */}
            <IconButton color="primary" aria-label="add emoji">
                <EmojiEmotionsIcon />
            </IconButton>

            {/* Send Button */}
            <IconButton 
                color="primary" 
                aria-label="send message" 
                onClick={handleSend}
                disabled={!message.trim()}
                sx={{ ml: 1, p: 1.5 }}
            >
                <SendIcon />
            </IconButton>
        </Paper>
    );
};